export const isAndroid = () => {
    return navigator.userAgent.match(/Android/i);
};
